/**
 * Tiny dev logger — silenced in production builds.
 * Use for diagnostic messages from catch blocks and graceful degradation paths.
 * For user-facing errors, prefer `toast.error(...)`.
 */
const isProd = process.env.NODE_ENV === 'production';

export const log = {
    warn: (...args) => { if (!isProd) console.warn(...args); },
    error: (...args) => { if (!isProd) console.error(...args); },
    info: (...args) => { if (!isProd) console.info(...args); },
};

export default log;
